export const ICON_DEFAULT_COLOR = '#8f9299';
export const COLOR_LIGHT = '#26D8C4';
export const SUN_COLOR = '#fdb813';